import Link from 'next/link'
import React from 'react'

import { DeprecatedText, ResponsiveImage, Spacer } from '@syconium/little-miss-figgy'
import { isServer } from '@syconium/weeping-figs'

import { useAuthentication } from '../../../../app/_providers/AuthenticationProvider.client'
import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { useUser } from '../../../../app/_providers/UserProvider.client'
import { imageSrcs } from '../../../../constants/figs'
import { GrayHorizontalBar, PageWidthContainer } from '../../../../lib/shared-styles'
import { ContentSection, ImageContentSplitContainer, ImageSection } from '../../account/styles'

import { LookupCreateForm } from './OrderLookupForm'
import { AccountLinkText, AccountLinkTextWrapper } from './styles'

const LoginOrSeeOrders: React.FC = () => {
  const { isLoggedIn } = useAuthentication()
  const { user } = useUser()
  const {
    magnolia: { orders: orderStrings },
  } = useTranslation()

  return (
    <div>
      {isLoggedIn ? (
        <>
          <DeprecatedText textType='h2'>{`You're logged in${
            user?.profile.firstName ? ', ' + user.profile.firstName : ''
          }.`}</DeprecatedText>
          <Spacer height={12} />
          <Link href='/account/orders'>
            <AccountLinkTextWrapper>
              <AccountLinkText>{orderStrings.seeMyOrders}</AccountLinkText>
            </AccountLinkTextWrapper>
          </Link>
        </>
      ) : (
        <>
          <DeprecatedText textType='h2'>{orderStrings.haveAccount}</DeprecatedText>
          <Spacer height={12} />
          <Link href='/account/login'>
            <AccountLinkTextWrapper>
              <AccountLinkText>{orderStrings.logIntoAccount}</AccountLinkText>
            </AccountLinkTextWrapper>
          </Link>
        </>
      )}
    </div>
  )
}

const Lookup: React.FC = () => {
  const {
    magnolia: { orders: ordersStrings },
  } = useTranslation()

  if (isServer) return null

  return (
    <>
      <DeprecatedText textType='h1' role='status' aria-live='polite'>
        {ordersStrings.viewOrderDetails}
      </DeprecatedText>
      <Spacer height={24} />
      <LookupCreateForm />
      <GrayHorizontalBar />
      <LoginOrSeeOrders />
      <Spacer height={75} />
    </>
  )
}

export const LookupPageView = () => {
  const {
    magnolia: {
      account: {
        login: {
          image: { alt },
        },
      },
    },
  } = useTranslation()

  return (
    <>
      <PageWidthContainer>
        <ImageContentSplitContainer>
          <ImageSection>
            <ResponsiveImage
              src={imageSrcs.login}
              alt={alt}
              aspectRatios={null}
              loading={'default'}
              widths={{
                unit: 'vw',
                sm: 0,
                md: 50,
              }}
            />
          </ImageSection>
          <ContentSection>
            <Lookup />
          </ContentSection>
        </ImageContentSplitContainer>
      </PageWidthContainer>
    </>
  )
}
